import { get } from 'config/api/config';

export interface InsuranceCriteriaResponse {
  isInsuranceRequired: boolean;
  isLeaseInsured: boolean;
}

export const getInsuranceCriteria = async (): Promise<InsuranceCriteriaResponse> => {
  const response = await get<InsuranceCriteriaResponse>('viewer/insurance-criteria');
  return response.data;
};
